export default "__VITE_ASSET__BhG0mYan__ 400w, __VITE_ASSET__BPwh7CeJ__ 800w, __VITE_ASSET__C2ucuby4__ 1024w";